// Navbar component

import { Box, IconButton } from "@mui/material";
import MenuIcon from '@mui/icons-material/Menu';
import NotificationBell from "../Notification/NotificationBell";

const Navbar = ({ handle_sidebar_toggle }) => {
  return (
    <>
      <Box className="z-[1000] top-0 left-0 w-full shadow border-b h-[60px] flex bg-white items-center justify-between" sx={{
        // bgcolor: "secondary.main"
      }}>
        <Box className="flex items-center">
          <IconButton edge="start" color="inherit" aria-label="menu" sx={{ mr: 2, ml: 1 }} onClick={handle_sidebar_toggle}>
            <MenuIcon />
          </IconButton>
          {/* <img
            className="h-[40px]"
            alt="pharma"
            src={"./sunpharma-logo.png"}
            height="40px"
          /> */}
        </Box>
        <Box className="flex justify-center items-center" sx={{ mr: 1 }}>
          {/* <NotificationBell /> */}
          <img
            className={"h-[40px]"}
            alt="Ripik Logo"
            src={"./ripik-logo.png"}
            height="40px"
          />
        </Box>
      </Box>
    </>
  );
};

export default Navbar;
